/**
 * Uniba Footer reducer
 * @module src/reducers/unibaFooterReducer
 */

import { GET_UNIBA_LANGUAGES } from 'design-comuni-plone-theme/actions';

const initialState = {
  error: null,
  hasError: false,
  result: {},
  loadingResults: false,
};

export const unibaLanguagesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_UNIBA_LANGUAGES}_PENDING`:
      return {
        ...state,
        loadingResults: true,
      };

    case `${GET_UNIBA_LANGUAGES}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loadingResults: false,
      };

    case `${GET_UNIBA_LANGUAGES}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loadingResults: false,
      };

    default:
      return state;
  }
};
